import { render, staticRenderFns } from "./AdminUtilitySftpTestFiles.vue?vue&type=template&id=21cf6fe0"
import script from "./AdminUtilitySftpTestFiles.vue?vue&type=script&lang=ts"
export * from "./AdminUtilitySftpTestFiles.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports